<template>
  <div>
    <Header>
      早期引出申請完了
    </Header>
    <div class="withdrawal-finished">
      <div class="px-3">
        <div class="text-center pt-5">
          <NoSalary />
          <p class="text-black text-size-18 text-weight-500">
            早期引出の申請が<br />完了しました
          </p>
        </div>
        <div class="summary-text">
          <p class="text-mild text-size-14">
            ご登録いただいている銀行口座をご確認ください。
          </p>
          <p class="text-mild text-size-14 mt-1">
            お振込みにはお時間を要する場合がありますが、24時間以上経過しても入金が確認できない場合、お問い合わせフォームよりご連絡ください。
          </p>
          <p class="text-mild text-size-14 mt-1">
            早期引出でエラーが発生した場合、営業日（土日祝を除く平日9:00〜18:00）で対応させていただきます。
          </p>
        </div>
        <RouterLink :to="{ name: 'Salary' }">
          <AppButtonOutline
            :block="true"
            class="text-primary-dark text-weight-500"
            >給与詳細へ戻る</AppButtonOutline
          >
        </RouterLink>
      </div>
    </div>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import Header from "@/components/organisms/common/Header.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { inAppReviewService } from "@/app/services/InAppReviewService";

@Component({
  components: {
    Header,
    AppButtonOutline,
    BlockBack
  }
})
export default class WithdrawalFinished extends Vue {
  async mounted() {
    await inAppReviewService.launchInAppReview("REQUEST_WITHDRAWAL");
  }
}
</script>
<style lang="scss" scoped>
.summary-text {
  padding: 40px 0;
}
</style>
